<script lang="ts">
	import { calculateWhenEnd } from '../../../../../helpers/interface_helpers';
	import { format } from 'svelte-i18n';
	import SingleRowViewWithControls from './SingleRowViewWithControls.svelte';
	import { week_days } from '../../../../../constants';
	import { getTimeFormat } from 'src/helpers/date_helper';

	export let active_time,
		disableDelete = false;

	const startAt = active_time?.indailyint?.startat || '00:00';
	const dur = active_time?.indailyint?.dur;

	/**
	 * Use the scene week day format from 1 to 7 (because of 0 errors)
	 */
	let active = active_time?.indailyint?.dows
		.trim()
		.split(' ')
		.map((el) => parseInt(el)) || [1, 2, 3, 4, 5, 6, 7];

	let value = {
		startTime: getTimeFormat(Number(startAt.split(':')[0]), Number(startAt.split(':')[1])),
		endTime: !active_time
			? getTimeFormat(23, 59)
			: getTimeFormat(
					Number(calculateWhenEnd(startAt, dur).split(':')[0]),
					Number(calculateWhenEnd(startAt, dur).split(':')[1]),
				),
	};

	let avatar = { icon: 'fa-thin fa-calendar' };
	let subtitle = {
		value: `${$format('start_time')}: ${value.startTime}`,
		bold: false,
	};
	let description = {
		value: `${$format('end_time')}: ${value.endTime}`,
		textSmall: false,
	};

	let days = week_days.map((el) => {
		let hasEl = active.find((e) => {
			return e === el.from_one_ind;
		});
		if (hasEl) {
			return {
				value: $format(el.i18n).charAt(0),
				active: true,
			};
		}
		return {
			value: $format(el.i18n).charAt(0),
			active: false,
		};
	});
</script>

<SingleRowViewWithControls
	{avatar}
	{subtitle}
	{description}
	{days}
	{disableDelete}
	withSchedule={true}
	on:edit
	on:delete
/>
